const trips = {
  table: {
    headers: {
      from: 'Pickup Location',
      to: 'Delivery Location',
      seats: 'Item Quantity',
      passenger: 'Recipient Name',
    },
  },
};

export default trips;
